import React, { PropsWithChildren } from 'react';
import { useDisclosure } from '@mantine/hooks';
import { Popover, type PopoverProps } from '@mantine/core';
import styled from 'styled-components';
import '@mantine/core/styles/Popover.css';
import { themeColor } from '../theme/colors';

export function TextTooltip({
  children,
  label,
  as = 'div',
  offset,
}: PropsWithChildren<{
  label: string | React.ReactNode;
  as?: string | React.ElementType;
  offset?: PopoverProps['offset'];
}>) {
  const [opened, { close, open }] = useDisclosure(false);
  const Wrapper = as;

  return (
    <Popover
      position="top"
      shadow="md"
      opened={!!label && opened}
      offset={offset}
      zIndex={2000}
    >
      <Popover.Target>
        <Wrapper onMouseEnter={open} onMouseLeave={close}>
          {children}
        </Wrapper>
      </Popover.Target>
      <StyledDropdown>{label}</StyledDropdown>
    </Popover>
  );
}

const StyledDropdown = styled(Popover.Dropdown)`
  color: ${themeColor('tooltipForeground')} !important;
  border: 1px ${themeColor('tooltipBorder')} solid;
  background-color: ${themeColor('tooltipBackground')} !important;

  border-radius: 2px;
  font-size: 12px;
  padding: 8px;
  max-width: 344px;

  word-break: break-all;

  pointer-events: none;
`;
